import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/common/Button';
import { UpgradePlanModal } from './UpgradePlanModal';

interface UpgradePlanButtonProps {
  variant?: 'funcionarios' | 'oposiciones';
}

export function UpgradePlanButton({ variant = 'funcionarios' }: UpgradePlanButtonProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const isOposiciones = variant === 'oposiciones';

  return (
    <>
      <Button
        onClick={() => setModalOpen(true)}
        variant="secondary"
        className="w-full justify-center gap-2"
      >
        <Sparkles className="h-4 w-4" />
        {isOposiciones ? 'Suscribirme' : 'Cambiar de plan'}
      </Button>
      <UpgradePlanModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        defaultTab={isOposiciones ? 'opositor' : 'pro'}
        lockTab
      />
    </>
  );
}
